import React, { useState } from "react";
import classNames from "classnames";

import { CityInfo } from "@/api/requests/getCityStateGeocode";
import publicConfig from "@/config/public";
import { Category } from "@/constants/events";
import { useEventTracker } from "@/hooks/useEventTracker";

import AddressCaptureModal from "@/components/AddressCaptureModal";
import Image from "@/components/Image";
import TrackImpression from "@/components/TrackImpression";

const {
  imgix: { publicUrl },
} = publicConfig;

const PreaddressMap: React.FC<{
  cityInfo?: CityInfo;
  className?: string;
  deliveryCount: number;
}> = ({ cityInfo, className, deliveryCount }) => {
  const [modalVisible, setModalVisible] = useState(false);

  const { publishEvent } = useEventTracker();

  const ref = React.useRef<HTMLButtonElement>(null);

  let nearWhere = "you"; // "99 dispensaries near you"
  if (cityInfo?.state && cityInfo?.city) {
    // \u00A0: non breaking space
    nearWhere = `${cityInfo.city},\u00A0${cityInfo.state}`; // "...near Tucson, AZ"
  } else if (cityInfo?.stateLong) {
    nearWhere = cityInfo.stateLong; // "...near Arizona"
  }

  const handleClick = () => {
    setModalVisible(true);

    publishEvent({
      action: "click",
      category: "Delivery Gate Flow",
      label: "map block",
    });
  };

  return (
    <TrackImpression
      category={Category.deliveryGateFlow}
      label="map block"
      className={classNames(
        "relative h-[400px] flex flex-col justify-end items-center",
        className,
      )}
    >
      <Image
        alt=""
        background
        className="after:content-[''] after:absolute after:left-0 after:top-0 after:w-full after:h-full  after:bg-gradient-to-b after:from-transparent after:to-white after:z-[1]"
        mobileSrc={`${publicUrl}/brands/mso-map/map_mobile.png`}
        sizes={[544, 767, 1023, 1440, null, 767]}
        src={`${publicUrl}/brands/mso-map/map_desktop.png`}
        tabletSrc={`${publicUrl}/brands/mso-map/map_tablet.png`}
      />
      <button
        onClick={handleClick}
        className="max-w-[300px] bg-white py-lg px-xl rounded shadow-low relative flex mb-28"
        ref={ref}
      >
        <span className="text-hero font-extrabold">{deliveryCount}</span>
        <span className="ml-lg">
          {`delivery dispensar${
            deliveryCount > 1 ? "ies" : "y"
          } near ${nearWhere}`}
        </span>
      </button>
      <AddressCaptureModal
        isVisible={modalVisible}
        onDismissed={() => setModalVisible(false)}
        returnFocusRef={ref}
      />
    </TrackImpression>
  );
};

export default PreaddressMap;
